import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface HeadingBaseProps {
  $margin?: 'none' | 'tiny' | 'small';
  $hyphensAuto?: boolean;
}

export const HeadingBase = styled.div<HeadingBaseProps>`
  display: block;
  margin-top: 0;
  margin-bottom: var(--heading-margin, ${size(2)});
  line-height: var(--heading-line-height, 1.4);
  letter-spacing: var(--heading-letter-spacing, -0.01em);
  font-family: var(--heading-font-family, var(--font-family));
  font-weight: var(--heading-font-weight, var(--font-weight-bold));
  text-wrap: balance;

  ${({ $margin }) =>
    $margin === 'none'
      ? css`
          --heading-margin: 0;
        `
      : $margin === 'tiny'
        ? css`
            --heading-margin: var(--heading-margin-tiny);
          `
        : $margin === 'small'
          ? css`
              --heading-margin: var(--heading-margin-small);
            `
          : undefined}

  ${({ $hyphensAuto }) =>
    $hyphensAuto &&
    css`
      hyphens: auto;
      overflow-wrap: break-word;
    `}
`;

export const H1 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h1',
}))`
  font-size: 2rem;

  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 1.5rem;
    line-height: 1.25;
  }

  ${(props) => props.theme.breakpoint.Sm} {
    line-height: 1.1428571429;
    letter-spacing: -0.03em;
  }
`;

export const H2 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h2',
}))`
  font-size: 1.5rem;

  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 1.25rem;
  }
`;

export const H3 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h3',
}))`
  font-size: 1.25rem;

  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 1.125rem;
  }
`;

export const H4 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h4',
}))`
  font-size: 1.125rem;

  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 1rem;
  }
`;

export const H5 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h5',
}))`
  font-size: 1rem;

  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 0.875rem;
  }
`;

export const H6 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h6',
}))`
  font-size: 0.875rem;
`;

export const HeadingTail = styled.span`
  font-weight: var(--font-weight-regular);
`;
